import { mediator } from '../../../mediator/mediatorInstance.js';

import { MainMapMarkerManager } from './MainMapMarkerManager.js';
import { setMarkerActiveState } from '../markerActiveState.js';

export class ArchiveMarkerManager extends MainMapMarkerManager {
    markerFactory;

    constructor(mapAdapter, markerFactory) {
        super(mapAdapter);
        this.markerFactory = markerFactory;
    }

    addMarkers(markerDataArray) {
        this.clearMarkersByType('archive');

        for(const data of markerDataArray) {
            const marker = this.markerFactory.createArchiveMarker(
                this.mapAdapter.getMapInstance(),
                data.name,
                data.lat,
                data.lng
            );

            marker.setActiveState = function(isActive) {
                // Aktiv-Zustand (Farbe + nach vorn holen) zentral, wie bei den Dokument-Markern.
                setMarkerActiveState(marker, isActive);
            }

            this._registerMarkerEvents(marker, data);
            this.addMarker(marker, data.id, 'archive', null, null);
        }
    }

    _registerMarkerEvents(marker, data) {
        marker.addListener('gmp-click', () => {
           mediator.publish('marker:archive:click', { data });
        });
        if(marker.content) {
            marker.content.addEventListener('mouseover', () => {
               mediator.publish('marker:archive:mouseover', { data });
            });
            marker.content.addEventListener('mouseout', () => {
                mediator.publish('marker:archive:mouseout', { data });
            })
        }
    }

    highlightMarkerById(id, active = true) {
        const markers = this.getMarkerById(id);
        if(!markers) { return; }
        for(const marker of markers) {
            if(marker.marker && typeof marker.marker.setActiveState === 'function') {
                marker.marker.setActiveState(active);
            } else if( import.meta.env.DEV ) {
                console.warn('Missing setActiveState handler for marker', marker.marker);
            }
        }
    }
}